import React from 'react'
import GetInTouch from './GetInTouch'
import AboutOffice from '../about/AboutOffice'
import DynamicBreadcrumb from '../../components/DynamicBreadcrumb'

const breadcrumbData = [
  {
    slug:"/",
    page:"Home",
  },
  {
    slug:"",
    page:"Contact Us",
  },
 
]

export default function ContactUs() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData}/>
       <GetInTouch />
       <AboutOffice />
    </>
  )
}
